// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-out-test[data-v-5d89d712] {\n  padding: 20px;\n  background-color: #fff;\n}\n.pay-out-test .result-container[data-v-5d89d712] {\n  margin-top: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
